import styled from 'styled-components';
import { Card } from '@perch-labs/shrike';

export const StyledCard = styled(Card)`
  background: #e3eeff;
  margin-bottom: 24px;
`;
